import React from 'react';
import { QueryClient } from 'react-query';

const SalesQueryClient = new QueryClient();

export default SalesQueryClient;
